import { ADD_TASK } from "./types";

export const addtask = (task) => ({ type: ADD_TASK, payload: task });
